/**
 * @file `<Key/>` — author-marked inline highlight: "the sentence to
 *       keep."
 * @module @labcraft/course-kit/components/key
 *
 * Renders as a `<mark>` so the emphasis survives copy/paste, reader
 * modes, and screen readers without any custom semantics. Pure render
 * — no extractor, scanner, or lab-state effect. Injected via
 * `<MdxProvider/>`'s component map, so chapters write:
 *
 *   Flakes pin every input, so <Key>the same flake builds the same
 *   system anywhere</Key> — that's the whole pitch.
 */

import type { JSX, ReactNode } from 'react'
import styles from './key.module.css'

/**
 * Props for `<Key/>`.
 *
 * @property children The highlighted span (inline prose).
 */
export interface KeyProps {
  children: ReactNode
}

/**
 * Inline highlighter span.
 *
 * @param props See {@link KeyProps}.
 * @returns The rendered `<mark>` highlight.
 */
export function Key(props: KeyProps): JSX.Element {
  return <mark className={styles.key}>{props.children}</mark>
}
